import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Box} from '@mui/material';
import PropTypes from 'prop-types';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Page from '../components/Page';
// sections
import LoginForm  from '../sections/auth/login/LoginForm';
// image
import logoMarca from '../images/logo.png';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'table',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(2, 0),
}));

Login.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

// ----------------------------------------------------------------------

export default function Login({ disabledLink = false, sx }) {
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');

  return (
    <Page title="Login">
      <RootStyle>
          <Container maxWidth="sm">
            <ContentStyle>
              <Box component="img" 
                  src={logoMarca} 
                  sx={{ width: 300, height: 280, ...sx }} 
              />
              
              <Typography variant="h4" gutterBottom>
                Entrar no Sistema
              </Typography>

              <Typography sx={{ color: 'text.secondary', mb: 5 }}>Insira seus dados abaixo.</Typography>

              <LoginForm />
              
              <Typography variant="body2" sx={{ mt: { md: 2 } }}>
                Não possui uma conta? {''}
                <Link variant="subtitle2" component={RouterLink} to="/register">
                  Cadastre-se
                </Link>
              </Typography>
            </ContentStyle>
          </Container>
      </RootStyle>
    </Page>
  );
}
